(ns storrito.editor.sticker
  (:require [storrito.editor.sticker-order :as sticker-order]
            [storrito.editor.centering :as centering]
            [storrito.fabricjs.state :as f]
            [storrito.app.message :as message]
            [storrito.editor.sticker-util :as sticker-util]))

(defn set-background-gradient!
  [^js fabric-element gradient]
  (.set fabric-element
        "fill"
        (js/fabric.Gradient.
          #js{:coords #js{:x1 0
                          :y1 0
                          :x2 fabric-element.width
                          :y2 fabric-element.height}
              :type "linear"
              :gradientUnits "pixels"
              :colorStops (sticker-util/convert-color-stops gradient)})))

(defn design-sticker
  [{:keys [text user-id design]}]
  (let [opacity (:opacity design)
        upper-case-text (.toUpperCase text)
        padding-x (:padding-x design
                    40)
        padding-y (:padding-y design
                    40)
        text-props (:text-props design)
        text-object (js/fabric.IText. upper-case-text
                                      (clj->js
                                        (merge {:originX "center"
                                                :originY "center"
                                                :fill "#000000"
                                                :fontSize 150
                                                :fontFamily "AvenyT"
                                                :text-align "center"}
                                               (when user-id
                                                 {:user-id user-id})
                                               text-props)))
        width (+ text-object.width padding-x)
        height (+ text-object.height padding-y)
        rect-object (js/fabric.Rect.
                      #js{:width width
                          :height height
                          :fill "#ffffff"
                          :originX "center"
                          :originY "center"
                          :opacity opacity
                          :rx (:rx design 30)
                          :ry (:ry design 30)})]

    (when (:gradient design)
      (set-background-gradient! text-object
                                (:gradient design)))

    [rect-object text-object]))

(defn create-sticker [params]
  ;; Bugfix for wrong text bounding boxes
  ;; Due to wrong calculated char width in cache, the cache needs to be cleared
  ;; Found at: https://github.com/kangax/fabric.js/issues/2612
  (js/fabric.util.clearFabricFontCache)
  (let [sticker-objects (design-sticker
                          (select-keys params
                                       [:text :user-id :design]))]
    (js/fabric.Group. (into-array sticker-objects)
      (clj->js (merge {:id (:id params)
                       :lockScalingFlip true
                       :min-scale 0.1
                       :max-scale 5.0
                       :dirty true
                       :top (:top params
                             10)
                       :left (:left params
                              10)
                       :angle (:angle params
                               0.0)
                       :scaleY (:scaleY params
                                0.8)
                       :scaleX (:scaleX params
                                0.8)}
                  (when (:user-id params)
                   {:user-id (:user-id params)}))))))

(defn add-sticker! [params]
  (try
    (if-let [fabric-canvas (f/get-canvas)]
      (let [fabric-object (create-sticker params)]
        (f/insert! fabric-canvas
                   (or
                     (:id params)
                     (str (:type params)
                          "-"
                          (random-uuid)))
                   fabric-object)
        (when (:centered? params)
          (centering/center! fabric-object))
        (sticker-order/sort-objects fabric-canvas)
        (f/set-active! fabric-object))
      (throw (ex-info "Canvas was nil" {})))
    (catch js/Error e
      (js/console.error e)
      (message/show-message! {:type :danger
                              :duration 8000
                              :content "Sorry we were not able to add this sticker. Please try again or contact the support."}))))

(defn update-sticker!
  [design]
  (try
    (if-let [fabric-canvas (f/get-canvas)]
      (->> (f/swap-object! fabric-canvas
                           (:id (f/get-active))
                           (fn [group]
                             (create-sticker (merge
                                               (select-keys group
                                                            [:id :top :left :scaleY :scaleX :angle :user-id])
                                               {:text (:text (.item group
                                                                    1))
                                                :design design}))))
           (f/set-active! fabric-canvas))
      (throw (ex-info "Canvas was nil" {})))
    (catch js/Error e
      (js/console.error e)
      (message/show-message! {:type :danger
                              :duration 8000
                              :content "Sorry we were not able to update this sticker. Please try again or contact the support."}))))

(comment

  (add-sticker! {:text "#TEST"
                 :scaleX 0.8
                 :scaleY 0.8
                 :top 600
                 :left 1000
                 :type "hashtag"
                 :design storrito.editor.sticker-design/default-hashtag-design})

  (add-sticker! {:text "@TIM90MAURER"
                 :scaleX 0.8
                 :scaleY 0.8
                 :top 600
                 :left 800
                 :type "hashtag"
                 :design storrito.editor.sticker-design/default-mention-design})

  )